import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Layout from '../../layouts/page';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { config } from '../../config';
import Spinner from '../../components/spinner';
import Dropdown from './dropdown';
import Pagination from '../../components/pagination';
import Backbtn from '../../components/backbtn';
import utils from '../../helpers/textEdit';

const Members = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const token = localStorage.getItem('auth_token');
  const estateID = localStorage.getItem('estateID');

  // Function to fetch estates
  const fetchMembers = (page) => {
    setLoading(true);
    axios
      .get(`${config.api_path}/customers?page=${page}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const filteredMembers = response.data.filter((item) => item.estate_id == estateID);
        setMembers(filteredMembers);
        setTotalPages(1); // Get total pages from response
        setCurrentPage(1); // Update current page
        setLoading(false);

        // Debug: Log email_verified_at for each member
        filteredMembers.forEach((member) => {
          console.log(
            `Member: ${member.name}, email_verified_at: ${member.email_verified_at}, Type: ${typeof member.email_verified_at}`
          );
        });
      })
      .catch((error) => {
        toast.error('Failed to fetch members. Please try again.');
        setLoading(false);
      });
  };

  useEffect(() => {
    document.title = 'Tuwe | Estates Members';
    setLoading(true); // Start loading
    fetchMembers(currentPage); // Fetch estates on component mount and when page changes
  }, [currentPage]);

  // Helper function to render the verification status badge
  const renderVerificationStatus = (email_verified_at) => {
    // Check if email_verified_at is undefined, null, or an empty string
    if (email_verified_at === undefined || email_verified_at === null || email_verified_at === '') {
      return (
        <span className="badge badge-danger" style={{ backgroundColor: 'red', color: 'white' }}>
          Not Verified
        </span>
      );
    } else {
      return (
        <span className="badge badge-success" style={{ backgroundColor: 'green', color: 'white' }}>
          Verified
        </span>
      );
    }
  };
  // Helper function to render the approval status badge
  const renderApprovalStatus = (status) => {
    if (status === 'Approved') {
      return (
        <span className="badge badge-success" style={{ backgroundColor: 'green', color: 'white' }}>
          Approved
        </span>
      );
    } else if (status === 'Denied') {
      return (
        <span className="badge badge-danger" style={{ backgroundColor: 'red', color: 'white' }}>
          Denied
        </span>
      );
    } else {
      return (
        <span className="badge badge-warning" style={{ backgroundColor: 'orange', color: 'white' }}>
          Pending
        </span>
      );
    }
  };
  

  return (
    <Layout>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <h3>Estates Members</h3>
            <Backbtn />
            <Link to="/estate-members/create">
              <button
                type="button"
                style={{ marginBottom: '10px', float: 'right' }}
                className="btn btn-outline-primary"
              >
                New Member
              </button>
            </Link>

            {loading ? (
              <Spinner />
            ) : (
              <>
                <span style={{ display: 'block', marginBottom: '10px' }}>
                  {'Viewing page ' + currentPage + ' of ' + totalPages + ' pages'}
                </span>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Verification Status</th>
                        <th>Approval Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {members ? (
                        members.map((person, index) => (
                          <tr key={person.id}>
                            <td>{(currentPage - 1) * 10 + index + 1}</td>
                            <td>
                              <Link to={`/estate-members/${person.id}`}>{person.name}</Link>
                            </td>
                            <td>{person.email}</td>
                            <td>{person.phone_number}</td>
                            <td>{renderVerificationStatus(person.email_verified_at)}</td>
                            <td>{renderApprovalStatus(person.status)}</td>
                            <td>
                              <Dropdown member={person} onDelete={() => fetchMembers(currentPage)} />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No estates member found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  setCurrentPage={setCurrentPage}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </Layout>
  );
};

export default Members;